import { Component, OnInit } from '@angular/core';
import { CallBackEndService } from '../call-back-end.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Router } from '@angular/router';
import { IbRequest } from '../ib-request';
import { IbResponse } from '../ib-response';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
declare var getHexAscii: any;
@Component({
  selector: 'app-change-password-after-expire',
  templateUrl: './change-password-after-expire.component.html',
  styleUrls: ['./change-password-after-expire.component.css']
})
export class ChangePasswordAfterExpireComponent implements OnInit {
error : string='';
  oldPassrequired:string='';
  OldPassword:string='';
  NewPassword:string='';
  newPassrequired:string='';
  ConfNewPassrequired:string='';
  ConfNewPassword:string='';
  msgforNewPassSpace:string='';
  msgforNewPassSplChar:string='';
  msgforNewPassLen:string='';
  messageForOneCapital:string='';
  messageForOneNumber:string='';
  confpassNotMatch:string='';
  regsplchar=/[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;
  regchar='/^[a-zA-Z]+$/';
  regexpspace=/\s+/;
  regZeroOnly='^[0][0]*[0]$';
  regNum = /^.*[0-9]/;
  regexcap =/^.*?[A-Z]/;
  invalidOtp:string='';
  userName:string=sessionStorage.getItem('storedUserName'); 
  otp:string='';
  messageForSamePass="";
  page:string="page1";
  isError1:boolean=false;
  errorDescription:string="";
  bankName: any;
  contactUsPage: string;
  atmBranch: string;
  constructor( private webService: CallBackEndService,
     private router:Router,
      private spinnerService: Ng4LoadingSpinnerService,private http: HttpClient) {
       
        this.getJSON().subscribe(data => {
          this.atmBranch = data.atmBranch;
          this.contactUsPage = data.contactUsPage;
         });    
        //  public getJSON(): Observable<any> {
        //   return this.http.get('assets/SampleUrl.json'); 
        // }
        this.bankName = this.webService.getBankName();

       }
      public getJSON(): Observable<any> {
          return this.http.get('assets/SampleUrl.json'); 
        }
  ngOnInit() {
    }
validateOldPassword()
{
 if (this.OldPassword === undefined || this.OldPassword === '') {
      this.oldPassrequired = 'no';
     
    }
}
validateNewPassword()
{
	console.log(this.NewPassword);
if (this.NewPassword === '' ||this.NewPassword===' ' ||this.NewPassword===undefined||this.NewPassword===null)
    {
      this.newPassrequired = 'no';
     

    }else if(this.NewPassword.match(this.regexpspace))
    {
      this.msgforNewPassSpace= 'no';
      
    }else if(!this.NewPassword.match(this.regsplchar))
    {
      this.msgforNewPassSplChar= 'no';
     
    }else if(this.NewPassword.length<8)
    {
      this.msgforNewPassLen = 'no';
     
    }else if(this.NewPassword.length>16)
    {
      this.msgforNewPassLen = 'no';
     
    }
    else if(!this.NewPassword.match(this.regexcap))
    {
      this.messageForOneCapital='no';
     

    }
    else if(!this.NewPassword.match(this.regNum))
    {
      this.messageForOneNumber='no';
      

    }else  if(this.NewPassword===this.OldPassword)
  {
   this.messageForSamePass='no';
  }
}
validateConfPassword()
{
 if (this.ConfNewPassword === '' ||this.ConfNewPassword===' ' ||this.ConfNewPassword===undefined||this.ConfNewPassword===null)
    {
      this.ConfNewPassrequired='no';
     
    }else if(!(this.ConfNewPassword===this.NewPassword))
    {
      this.confpassNotMatch='no';
      

    }
}
clearOldPassword()
{
 this.oldPassrequired = '';
 this.error='';
}
clearNewPassword()
{

this.newPassrequired="";
    this.msgforNewPassSpace='';
    this.msgforNewPassSplChar="";
    this.msgforNewPassLen="";
    this.messageForOneCapital="";
    this.messageForOneNumber="";
	this.messageForSamePass=''; 
	this.error='';


}
clearConfPassword()
{
  this.ConfNewPassrequired='';
	this.confpassNotMatch='';
	this.error='';
}
changePassWord()
{
	
 if (this.otp === undefined || this.otp === '') {
      this.invalidOtp = 'no';
     
    }else{
       this.spinnerService.show();
    const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
    
      request.param1 = getHexAscii('', this.userName+this.OldPassword+ this.NewPassword+this.otp);
      request.param2 = this.userName;
      request.param3 =  getHexAscii('',this.OldPassword);
      request.param4 =  getHexAscii('' ,this.NewPassword);
      request.param5 =  getHexAscii('' ,this.otp);
      this.webService.getResponse(request, 'changePasswordAfterExpire').subscribe((data: IbResponse) => {
         
        this.spinnerService.hide();
        response = data;
        if (response !== null && response.status === 'S200')  {
          this.error=response.param1;
          //this.isShow='page3';
		  // console.log('OTP'+JSON.stringify(response.param1));
		    sessionStorage.setItem('showSuccessMsg', response.param1);
         this.router.navigate(['/show-success']);
        } else if (response !== null) {
		  this.errorDescription = response.param1;
		  this.isError1=true;
        } else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
        }
      });

	}
 }
 generateOtp()
 {
	 
	if (this.OldPassword === undefined || this.OldPassword === '') {
      this.oldPassrequired = 'no';
     
    }else if (this.NewPassword === '' ||this.NewPassword===' ' ||this.NewPassword===undefined||this.NewPassword===null)
    {
      this.newPassrequired = 'no';
     

    }else if(this.NewPassword.match(this.regexpspace))
    {
      this.msgforNewPassSpace= 'no';
      
    }else if(!this.NewPassword.match(this.regsplchar))
    {
      this.msgforNewPassSplChar= 'no';
     
    }else if(this.NewPassword.length<8)
    {
      this.msgforNewPassLen = 'no';
     
    }else if(this.NewPassword.length>16)
    {
      this.msgforNewPassLen = 'no';
     
    }
    else if(!this.NewPassword.match(this.regexcap))
    {
      this.messageForOneCapital='no';
     

    }
    else if(!this.NewPassword.match(this.regNum))
    {
      this.messageForOneNumber='no';
      

    }else  if(this.NewPassword===this.OldPassword)
  {
   this.messageForSamePass='no';
  }else if (this.ConfNewPassword === '' ||this.ConfNewPassword===' ' ||this.ConfNewPassword===undefined||this.ConfNewPassword===null)
    {
      this.ConfNewPassrequired='no';
     
    }else if(!(this.ConfNewPassword===this.NewPassword))
    {
      this.confpassNotMatch='no';
      

    }else{
	const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
    
      request.param1 = getHexAscii('',this.userName);
      request.param2 = this.userName;
      this.webService.getResponse(request, 'generateOtpBeforeLogin').subscribe((data: IbResponse) => {
      //  this.spinnerService.hide();
		response = data;
		 this.spinnerService.hide();
        if (data.status === 'S101') {
		console.log("Malicious  Request Detected");
		
		}else 
        if (response !== null && response.status === 'S200')  {
          
         this.page='page2'; 
          console.log('OTP'+JSON.stringify(response.param1));
        } else if (response !== null) {
          this.error = response.param1;
        } else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
        }
	  });
	}
 }
  validateOtp() {
    if (this.otp === undefined || this.otp === '') {
      this.invalidOtp = 'no';
     
    }
  }
   clearOtp() {
    this.invalidOtp = '';
   
  }
  openPage1()
  {
	  this.page="page1";
  }
  goToLink1(){
    //  window.open('http://www.abhinavbank.com/branch.asp','_blank');
    window.open(this.atmBranch,'_blank');

    //window.location.href='#/Disclaimer';
  }
  goToLink2(){
    // window.open('https://www.maheshbankpune.in/contact-us.html','_blank');
    // window.open('http://www.abhinavbank.com/contact.asp','_blank'); 
    window.open(this.contactUsPage,'_blank'); 

  }
}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/change-password-after-expire/change-password-after-expire.component.ts